import { Component, Input } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { notesValidationMessages, NotesValidator } from '@helios/validators'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-edit-transaction-note-modal',
  templateUrl: './edit-transaction-note-modal.component.html',
  styleUrls: ['./edit-transaction-note-modal.component.scss'],
})
export class EditTransactionNoteModalComponent {
  noteControl = new FormControl('', NotesValidator())
  form = new FormGroup({ noteTextArea: this.noteControl })

  validationMessages = { notesValidationMessages }

  @Input()
  get noteText(): string {
    return this.noteControl.value
  }
  set noteText(value: string) {
    this.noteControl.setValue(value)
  }

  constructor(public activeModal: NgbActiveModal) {}

  onSubmit() {
    this.activeModal.close(this.noteText)
  }

  onCancel() {
    this.activeModal.dismiss()
  }
}
